import React from "react";
import { Helmet } from "react-helmet";
import "../../../Styles/Redirecting Styles/FooterStyle/Policy.css";

import CanadaHeader1 from "../../Components/seperate Components/CanadaHeader1";
import CanadaFooter from "../../Components/Footer";

const CanadaPolicy = () => {
  return (
    <div>
      <Helmet>
        <title>Zithas Technologies Privacy Policy | Data Protection & Usage</title>
        <meta
          name="description"
          content="Explore Zithas Technologies' privacy policy. Learn about data protection, usage, and our commitment to safeguarding your information."
        />
      </Helmet>

      {/* Header */}
      <CanadaHeader1 />

      {/* Banner Section */}
      <div
        className="bd-page-title-area bd-page-title-bg_policy pt-175 pb-155 main-privacy-responsive"
        style={{ height: "380px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="bd-page-title text-center z-index">
                <h2
                  className="breadcrumb-title"
                  style={{ fontSize: "50px", color: "#4a026c" }}
                >
                  Privacy Policy
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Policy Content Section */}
      <section
        className="bd-about-area-two ml-50 pt-140 pb-120 policy-responsive"
        style={{ width: "95%" }}
      >
        <div className="policy-content">
          {/* Main Title */}
          <h1>Privacy Policy for Zithas Technologies</h1>
          <p className="policy-text"> At Zithas Technologies, we prioritize the privacy of our website visitors. Our Privacy Policy, available at www.zithas.com, outlines the information we collect, how we use it, and provides contact details for further inquiries or information requests via email at hello@zithas.com.
          </p>

          {/* CCPA Section */}
          <h1 className="mt-4">General Data Protection Regulation(GDPR)</h1>
          <p className="policy-text">
          As a Data Controller of your information, Zithas Technologies Ltd. abides by the principles outlined in our Privacy Policy. The collection and use of personal information by Zithas Technologies Ltd. are based on various factors, including the nature of the information and the specific context of its collection. These may include the need to fulfill a contract with you, your explicit consent, our legitimate interests, or legal obligations.
            <br /><br />
            <strong>To ensure compliance with our legal obligations, resolve disputes, and enforce our policies, Zithas Technologies Ltd. retains your personal information for only as long as necessary for the purposes stated in our Privacy Policy.:</strong> 
            <br /><br />
            <strong>If you are a resident of the European Economic Area (EEA), you have specific data protection rights. You can contact us to inquire about the personal information we hold about you and request its removal from our systems. Additionally, you have the right to access, update, or delete your information, rectify any inaccuracies, object to the processing of your data, restrict its usage, request data portability, and withdraw your consent when applicable:</strong> 
            <br /><br />
          </p>

             {/* Main Title */}
             <h1>California Consumer Privacy Act (CCPA)</h1>
          <p className="policy-text"> As a business, Zithas Technologies Ltd. respects the privacy rights of California residents under the California Consumer Privacy Act (CCPA). We collect personal information based on factors such as the need to fulfill a contract, your consent, our legitimate interests, or legal obligations.
          To comply with CCPA, we retain personal information only as necessary for the purposes outlined in our Privacy Policy. If you are a California resident, you have rights to request access to, deletion of, or a copy of your personal data. You also have the right to opt out of the sale of your data (we do not sell personal data) and to receive non-discriminatory treatment when exercising your rights.
          </p>
          {/* Log Files */}
          <h1 className="mt-4">Log Files</h1>
          <p className="policy-text">
          Zithas Technologies adheres to a standard protocol of utilizing log files, a practice common among hosting companies and integral to hosting services' analytics. The information logged includes internet protocol (IP) addresses, browser types, Internet Service Providers (ISPs), timestamps, referring/exit pages, and potentially the number of clicks. These details are not linked to personally identifiable information. The collected information serves the purpose of analyzing trends, administering the website, tracking user navigation, and gathering demographic data.
          </p>

          {/* Cookies */}
          <h1 className="mt-4">Cookies and Web Beacons</h1>
          <p className="policy-text">
          Similar to other websites, Zithas Technologies utilizes cookies. These cookies store information such as visitors' preferences and the specific pages they accessed or visited on our website. This information is employed to enhance the user experience by tailoring our web page content according to visitors' browser type and other relevant details.  
          </p>
          {/* Cookies */}
          <h1 className="mt-4">Privacy Policy</h1>
          <p className="policy-text">To access the Privacy Policy of Zithas Technologies' advertising partners, you can refer to the provided list. Third-party ad servers or ad networks may employ technologies like cookies, JavaScript, or Web Beacons in their advertisements and links displayed on Zithas Technologies. These technologies are directly sent to users' browsers, and the IP address is automatically received in the process. Their purpose is to measure the effectiveness of advertising campaigns and/or personalize the advertising content visible on the websites you visit. It's important to note that Zithas Technologies has no control over or access to the cookies used by third-party advertisers.
          </p>

          {/* Third Party Policy */}
          <h1 className="mt-4">Third Party Privacy Policy</h1>
        <p  className="policy-text">
        Please note that Zithas Technologies' Privacy Policy solely applies to our own website and does not extend to other advertisers or external websites. We recommend consulting the Privacy Policies of these third-party ad servers for more comprehensive information, including their practices and instructions on how to opt-out of certain options. A complete list of Privacy Policies and corresponding links can be found here: Privacy Policy Links.
          </p>

          {/* Children’s Privacy */}
          <h1 className="mt-4">Children’s Information</h1>
          <p className="policy-text">
          Safeguarding children while they use the internet is an important aspect of our commitment. We urge parents and guardians to actively observe, participate in, and monitor their children's online activities, providing guidance when necessary.
          <br />
          Zithas Technologies does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you believe that your child has unintentionally provided such information on our website, please contact us immediately. We will make every effort to promptly remove such information from our records.
          <br />
          </p>

          {/* Online-Only Policy */}
          <h1 className="mt-4">Online Privacy Policy Only</h1>
          <p className="policy-text">
          Our Privacy Policy, which is created and available at GDPRPrivacyPolicy.net, specifically pertains to our online activities and is applicable to visitors of Zithas Technologies' website in terms of the information they share or collect. Please note that this policy does not extend to any offline information collection or through channels other than this website.
          </p>

          {/* Consent */}
          <h1 className="mt-4">Consent</h1>
          <p className="policy-text">
          By utilizing our website, you are giving your consent and agreeing to abide by our Privacy Policy and its terms.
        </p>
        </div>
      </section>

      {/* Footer */}
      <CanadaFooter />
    </div>
  );
};

export default CanadaPolicy;
